import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const ImageSmall = ({ imageSmall }) => {
  const base =
    'relative w-full max-w-[205px] md:max-w-[400px] mx-auto lg:m-0 aspect-[3/4] mt-largeMobile lg:mt-mediumDesktop'

  return (
    <div className={base}>
      <Image
        src={urlForImage(imageSmall).url()}
        alt={imageSmall.alt}
        fill
        placeholder="blur"
        blurDataURL={imageSmall.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default ImageSmall
